import { Component, Input } from '@angular/core';

@Component({
  selector: 'avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent {
  @Input() name!: string;
  userInitials!: string;
  backgroundColor!: string;

  ngOnChanges() {
    if (this.name) {
      // Generate user initials from the name
      const nameParts = this.name.split(' ');
      if (nameParts.length >= 2) {
        this.userInitials = nameParts[0][0] + nameParts[1][0];
      } else {
        this.userInitials = this.name[0];
      }

      // Generate a deterministic background color based on the name
      this.backgroundColor = this.stringToColor(this.name);
    }
  }

  stringToColor(string: any) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }
}
